import React, { useState } from 'react';
import { Button, Collapse } from 'reactstrap';
import { useAppContext, useTranslator } from '@front-activerse/common-components';

interface Props {
  count: number;
  children: React.ReactNode;
}

const TrackerShoppingListBought: React.FC<Props> = ({ count, children }) => {
  const { t } = useTranslator();
  const [isOpen, setIsOpen] = useState(false);
  const {
    svgInline: { DownArrow },
  } = useAppContext();

  return (
    <section className="bought-section py-m px-m mt-l">
      <Button className="bought-button d-print-none p-0" onClick={() => setIsOpen((prev) => !prev)}>
        {t('shoppingList.bought.title')}
        <span className={isOpen ? 'collapse-arrow open' : 'collapse-arrow'}>
          <span className="SVGInline">
            <DownArrow />
          </span>
        </span>
      </Button>

      <Collapse className="d-print-none" isOpen={isOpen}>
        {count > 0 ? (
          <ul className="ingredients">{children}</ul>
        ) : (
          <p className="no-products m-0">{t('shoppingList.bought.noProducts')}</p>
        )}
      </Collapse>
    </section>
  );
};

export default TrackerShoppingListBought;
